export const billingConstants = {
    GET_ORDER_INVOICING_CONFIGURATION_REQUEST: "GET_ORDER_INVOICING_CONFIGURATION_REQUEST",
    GET_ORDER_INVOICING_CONFIGURATION_SUCCESS: "GET_ORDER_INVOICING_CONFIGURATION_SUCCESS",
    GET_ORDER_INVOICING_CONFIGURATION_FAILURE: "GET_ORDER_INVOICING_CONFIGURATION_FAILURE",

    // Template fetch invoices data to display invoice
    GET_INVOICE_DATA_REQUEST: "GET_INVOICE_DATA_REQUEST",
    GET_INVOICE_DATA_SUCCESS: "GET_INVOICE_DATA_SUCCESS",
    GET_INVOICE_DATA_FAILURE: "GET_INVOICE_DATA_FAILURE",

    // Template fetch creditnotes data to display creditnotes
    GET_CREDIT_NOTE_DATA_REQUEST: "GET_CREDIT_NOTE_DATA_REQUEST",
    GET_CREDIT_NOTE_DATA_SUCCESS: "GET_CREDIT_NOTE_DATA_SUCCESS",
    GET_CREDIT_NOTE_DATA_FAILURE: "GET_CREDIT_NOTE_DATA_FAILURE",

    GET_ALL_DOCUMENTS_REQUEST: "GET_ALL_DOCUMENTS_REQUEST",
    GET_ALL_DOCUMENTS_SUCCESS: "GET_ALL_DOCUMENTS_SUCCESS",
    GET_ALL_DOCUMENTS_FAILURE: "GET_ALL_DOCUMENTS_FAILURE",

    GET_ORDER_DATA_REQUEST: "GET_ORDER_DATA_REQUEST",
    GET_ORDER_DATA_SUCCESS: "GET_ORDER_DATA_SUCCESS",
    GET_ORDER_DATA_FAILURE: "GET_ORDER_DATA_FAILURE",
};
